import { render, staticRenderFns } from "./ProductFamilyInno.vue?vue&type=template&id=7afefeda&"
import script from "./ProductFamilyInno.vue?vue&type=script&lang=js&"
export * from "./ProductFamilyInno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports